import type { MaterialKind } from "../../../shared/api-contract";
import { usesDmat } from "../library/materialRouting";
import type { PresetMark } from "./applyEngine";

/**
 * The Basic engine's rule for what KIND of part a material leaves behind —
 * pure, so the customer configurator's "+" picker can ask the same question
 * before it applies anything (and a check can prove it without a browser).
 * `BasicEngine` routes every apply by these two functions.
 */

/** Is this file mark a diamond (.dmat, or a .pmat that declared itself one)? */
export function isDmatMark(mark: PresetMark, kind: MaterialKind): boolean {
  return !!mark.url && (mark.dmat ?? usesDmat(mark.url, mark.category ?? kind));
}

/**
 * The kind of part a mark leaves behind. A material file decides by its own
 * format; a built-in ceramic / pearl / enamel is PBR, which the viewer files
 * as metal; a named preset keeps `fallback` (the kind it is applied AS).
 */
export function markKind(mark: PresetMark, fallback: MaterialKind): MaterialKind {
  if (mark.url) return isDmatMark(mark, fallback) ? "gem" : "metal";
  if (mark.category === "gem" || mark.category === "metal") return mark.category;
  if (mark.category) return "metal";
  return fallback;
}
